import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { emptyObject } from 'ui-components/default-props/empty';
import { ServiceGroupSelector } from '../../../fulfillment-planner/shipping-service/service-group-selector';
import { ACCESS_LEVELS, useRequiresRateShopperAccessLevel } from '../../../hooks/use-has-rate-shopper-access-level';
import Global from '../../../store/global-selectors';
import { ShippingServiceSelector } from '../../shipping-service-selector';
import { useProviderOrCarrierGroups } from '../../shipping-service-selector/group-hooks/use-provider-or-carrier-groups';
import { useServiceCollectionGroup } from '../../shipping-service-selector/group-hooks/use-service-collection-group';
import { useSelectedItemName } from '../../shipping-service-selector/use-selected-item-name';
import { shippingService } from '../constants';
import { messages } from '../messages';
import style from './shipping-service.module.css';

export const ShippingServicePresetOption = ({ data = emptyObject, onChange, setSelectedService }) => {
  const allServices = useSelector(Global.selectSellerServices);

  const onServiceChange = useCallback(
    ({ serviceId, sellerLabelProviderId, labelProviderId, serviceCollectionGuid }) => {
      setSelectedService(labelProviderId);
      onChange({
        name: shippingService,
        value: {
          serviceId,
          sellerLabelProviderId,
          providerId: labelProviderId,
          serviceCollectionGuid,
        },
      });
    },
    [onChange, setSelectedService],
  );

  const selectedItemName = useSelectedItemName({
    serviceId: data?.serviceId || data,
    serviceCollectionGuid: data?.serviceCollectionGuid,
  });
  const providerGroups = useProviderOrCarrierGroups(allServices, data);
  const serviceCollectionGroup = useServiceCollectionGroup(data);
  const showRateShopper = useRequiresRateShopperAccessLevel(ACCESS_LEVELS.FREEMIUM);
  if (showRateShopper) {
    providerGroups.unshift(serviceCollectionGroup);
  }

  return (
    <>
      <FlexRow className={style['label-and-grouping-selector']}>
        <Text textType={TextType.Label} value={messages.shippingService} />
        <ServiceGroupSelector shouldUseNewStyle />
      </FlexRow>
      <ShippingServiceSelector onSelected={onServiceChange} selectedItemName={selectedItemName} serviceGroups={providerGroups} />
    </>
  );
};

ShippingServicePresetOption.propTypes = {
  data: PropTypes.shape({
    serviceId: PropTypes.string,
    serviceCollectionGuid: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  setSelectedService: PropTypes.func.isRequired,
};
